// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c9bcd251","371":"e7b8d8c9","667":"72d8a0a4"}[chunkId] + ".chunk.js";
};